import { Box } from "@chakra-ui/react";
import DropDown from "./components/DropDown";
import PopUp from "./components/PopUp";
import SearchBar from "./components/SearchBar";
import Tabs from "./components/Tabs";
import Drawer from "./components/Drawer";
import Header from "./components/Header";
import Password from "./components/Password";
import Button from "./components/Button";

function App() {
  return (
    <Box>
      <Header />
      <DropDown />
      <PopUp />
      <SearchBar />
      <Tabs />
      <Drawer />
      <Password />
      <Button />
    </Box>
  );
}

export default App;

// bolder  ==== Protest Riot
